import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import WixelIcon from '@wix/da-ds/pkg/Icons/24x24/Wixel';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { navigateToWixel } from '../../../../../actions/studio/playground';
import { BiData, type DefaultBiEvent } from '@wix/da-bi/pkg/events';

interface Props {}

const CreateWithWixelButton: FC<Props> = () => {
  const { t } = useTranslation();
  const dispatchNavigateToWixel = useAction(navigateToWixel);

  return (
    <TextButton
      variant="main"
      icon={WixelIcon}
      size="large"
      onClick={dispatchNavigateToWixel}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'wixel-playground-corner-cta',
      })}
    >
      {t('studio.header.tabs.playground.cta.wixel')}
    </TextButton>
  );
};

CreateWithWixelButton.displayName = 'CreateWithWixelButton';

export default CreateWithWixelButton;
